// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3856035a","102":"7f8f721a","224":"903cec6a","283":"acfca8c6","302":"bbc81d58","549":"8ef4442b","662":"bfcdd108","705":"25230220","755":"b4a9b3c2","839":"a1f1a133","848":"64569aa4","921":"1b7cbe53","955":"65ee0fae","995":"f20c8930"}[chunkId] + ".chunk.js";
};